import { CSSTransition } from 'react-transition-group';
import garageIcon from '~/assets/icons/garage.svg';
import plus from '~/assets/icons/plus.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { useLayoutSelector } from '../../redux';
import {
	StyledAddSlotsButton,
	StyledContainer,
	StyledParkingSlotsContainer,
	StyledParkingSlotsFull,
} from './ParkingSlotsInfo.styled';

const ParkingSlotsInfo = () => {
	const availableSlots = useObservable(rage.player.getTotalParkingSlots());
	const usedSlots = useObservable(rage.player.getUsedParkingSlots());
	const parkingSlotsErrorVisible = useLayoutSelector(
		(state) => state.player.parkingSlotsErrorVisible,
	);

	return (
		<StyledContainer>
			<CSSTransition
				in={parkingSlotsErrorVisible}
				timeout={300}
				classNames="fade"
				unmountOnExit
			>
				<StyledParkingSlotsFull>
					<Text>К сожалению, у вас недостаточно гаражных мест</Text>
				</StyledParkingSlotsFull>
			</CSSTransition>
			<StyledParkingSlotsContainer>
				<img src={garageIcon} width={16} height={16} />
				<Divider $direction="V" style={{ opacity: 0.1 }} />
				<Text style={{ fontSize: 18, fontWeight: 500, color: '#ffffff' }}>
					{usedSlots}
					<span style={{ fontSize: 16, fontWeight: 400, opacity: 0.5 }}>
						&#160;/ {availableSlots}
					</span>
				</Text>
			</StyledParkingSlotsContainer>
			<StyledAddSlotsButton
				onClick={() => {
					rage.player.showBuyParkingSlotsModal();
					playSound(Sound.ClickButton);
				}}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			>
				<img src={plus} />
			</StyledAddSlotsButton>
		</StyledContainer>
	);
};

export { ParkingSlotsInfo };
